import { service } from '../../../helpers/http'


export const ActionIndexBranches = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'branch', 
		action: 'indexBranches', 
		payload: payload 
	})
}